import React from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import { SavedBillingPayload } from "@/app/models/checkout/types";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditNoteIcon from '../../../img/edit-icon.svg';

export type BillingInformationSavedProps = {
  accountNumber: string;
  customerName: string;
  savedBillingPayload: SavedBillingPayload;
  attachments: File[];
  onEdit: () => void;
};

const BillingInformationSaved: React.FC<BillingInformationSavedProps> = ({
  accountNumber,
  customerName,
  savedBillingPayload,
  attachments,
  onEdit
}) => {
  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <CheckCircleIcon sx={{ color: "#64A70B", padding: "1px", fontSize: "36px", mr: 1, }} />
          <Typography className='checkout-container-title'>
            Contact Information
          </Typography>

          <Divider className="checkout-divider" />
        </Box>
      </Box>

      <Box sx={{ border: '10px solid', borderColor: 'grey.300', borderRadius: 2, p: 3 }}>
        <Grid container alignItems="flex-start">

          <Grid item xs={12} md={5}>
            <Box sx={{ mb: 0.5 }}>
              <Typography component="span" fontWeight={700} fontSize={14}>
                Account Number :
              </Typography>{" "}
              <Typography component="span" fontSize={14}>{accountNumber}</Typography>
            </Box>

            <Box sx={{ mb: 0.5 }}>
              <Typography component="span" fontWeight={700} fontSize={14}>
                Customer Name:
              </Typography>{" "}
              <Typography component="span" fontSize={14}>{customerName}</Typography>
            </Box>

            <Box>
              <Typography component="span" fontWeight={700} fontSize={14}>
                Job Name or PO:
              </Typography>{" "}
              <Typography component="span" fontSize={14}>{savedBillingPayload.jobName}</Typography>
            </Box>
          </Grid>

          {savedBillingPayload.currentBillingAccount &&
            <Grid item xs={12} md={5}>
              <Typography fontWeight={700} sx={{ mb: 0.5 }} fontSize={14}>
                Current Billing Account:
              </Typography>
              <Typography sx={{ lineHeight: 1.6 }} fontSize={16}>
                {savedBillingPayload.currentBillingAccount}
              </Typography>
            </Grid>
          }

          <Grid item xs={12} md={!savedBillingPayload.currentBillingAccount ? 7 : 2} display="flex" justifyContent="flex-end" alignItems="flex-start">
            <Button
              id="billing-edit-btn"
              type="button"
              onClick={onEdit}
              startIcon={<img src={EditNoteIcon} alt="" />}
              sx={{ fontWeight: 700, color: "#003B5C", textTransform: "none" }}>
              Edit
            </Button>
          </Grid>
        </Grid>

        {attachments?.length > 0 && (
          <Box sx={{ mt: 3 }}>
            <Typography className="bold-text-field" fontWeight={700} sx={{ mb: 1 }}>
              Attachments:
            </Typography>
            <Box id="attachments-names" sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              {attachments.map((file: File, i: number) => {
                if(!(file instanceof File) || file.size === 0)
                    return;

                const fileUrl = URL.createObjectURL(file);

                return (
                  <Link
                    key={i}
                    href={fileUrl}
                    className='attachment-file-name'
                    underline="hover"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {file.name}
                  </Link>
                );
              })}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default BillingInformationSaved;
